import {
  FieldText,
  type FieldTextProps,
} from '@/components/PaymentMethod/fields/FieldText';
import type { Country } from '@/helpers/conf';
import { useGetCommonStore } from '@/store';
import { getCustomWarningValidatorsByFieldName } from '../helpers/customValidators';

export const FieldTextWithdraw = ({ ...props }: FieldTextProps) => {
  const useCommonStore = useGetCommonStore();

  const userCountry = useCommonStore(
    (s) => s.user?.country as Country | undefined
  );

  const validatorWarning = userCountry
    ? getCustomWarningValidatorsByFieldName(props.fieldName, userCountry)
    : undefined;

  return <FieldText {...props} validatorWarning={validatorWarning} />;
};
